import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import { BreadcrumbConfigProps } from '../../config/InterfacesAndTypes';
import { Typography } from 'antd';

interface ToolBarProps {
  breadcrumbs?: BreadcrumbConfigProps;
  children?: any;
  title: string;
}

const ToolBar: React.FC<ToolBarProps> = ({ breadcrumbs, title, children }) => {
  const { Title } = Typography;

  return (
    <>
      {breadcrumbs && (
        <div className="breadcrumbs" key={111}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
      )}
      <div className="mainPageHeader" key={112}>
        <Title className="title" key={113}>
          {title}
        </Title>
        <div className="btnWrap" key={114}>
          {children}
        </div>
      </div>
    </>
  );
};

export default ToolBar;
